<template>
  <v-row>
    <v-col cols="12" sm="4" class="font-weight-bold">
      <ressource :code="'info_' + code" />
    </v-col>
    <v-col cols="12" sm="8">
      {{ value }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    code: String,
    value: String
  }
}
</script>

<style>
</style>